import styles from "./Authentication.module.scss";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userProfile } from "../../../../actions/user";
import {
  hiddenLoadingPage,
  showLoadingPage,
} from "../../../../actions/loadingPage";
import { LoadingPage } from "../../../LoadingPage/LoadingPage";
import { usersVerifyInfo } from "../../../../services/userServices";
import {
  checkEmailCode,
  checkPhoneCode,
  sendEmailCode,
  sendPhoneCode,
} from "../../../../services/adminServices";
import { errorMessage, successMessage } from "../../../../utils/messages";
//Icons
import ArrowBackIcon from "../../../../styles/icon/arrow_back_fill.svg";
import ArrowRightIcon from "../../../../styles/icon/arrow_wallet.svg";
import UserFillIcon from "../../../../styles/icon/menu/User_fill.svg";
import ScanIcon from "../../../../styles/icon/ScanIcon.svg";
import Confirmed from "../../../../styles/icon/Confirmed.svg";
import NotConfirmed from "../../../../styles/icon/NotConfirmed.svg";
import pendingIcon from "../../../../styles/icon/pending.svg";
{
  /*Accept Rules Component */
}
export const UserAcceptRules = ({ UserRulesInfo, SetAcceptRules }) => {
  return (
    <div className={styles.Rules_container}>
      <div className={`font_color_white ${styles.rules_text}`}>
        <p>
          کاربران موظفند قبل از ثبت‌نام تمامی مفاد این تعهدنامه را مطالعه نموده
          و صرفا در صورت پذیرش آن اقدام به ثبت نام نمایند. کاربران سایت
          می‌پذیرند که کلیه‌ی فعالیت‌های آن‌ها در ارزفی در چارچوب قوانین جمهوری
          اسلامی بوده و هیچ گونه فعالیتی خارج از این چارچوب انجام نخواهند داد.
          احراز هویت برای استفاده از خدمات ارزفی ضروری بوده و کاربران موظفند
          اطلاعات صحیح خود را بارگذاری نمایند. بدیهی است در صورت وجود هرگونه
          تخلف در احراز هویت، مسئولیت به عهده‌ی فرد متخلف بوده و ارزفی حق توقف
          ارائه خدمات به کاربر مذبور و ارجاع موارد تخلف به مراجع ذی صلاح را
          خواهد داشت. ارزفی خود را ملزم به حفظ اطلاعات شخصی کاربران خود می‌داند.
          کاربران ارزفی تعهد می دهند که از خدمات سایت ارزفی تنها برای خود
          استفاده نموده و مسئولیت استفاده از خدمات ارزفی برای فرد غیر که فرآیند
          احراز هویت را طی نکرده باشد به عهده کاربر خواهد بود. شماره حساب اعلام
          شده به سایت و همچنین آدرس کیف پول ها جهت برداشت رمزارز نیز می بایست
          متعلق به کاربر بوده و کاربران مجاز به دادن آدرس کیف پول متعلق به اشخاص
          دیگر نیستند. کاربران ارزفی می‌پذیرند در صورت تشخیص کارشناسان پشتیانی
          ارزفی، جهت حفظ امنیت دارایی حساب کاربریشان با اطلاع قبلی نسبت به
          برقراری تماس تصویری با تیم ارزفی همکاری نمایند. همچنین بنا به دستور
          نهادهای قضایی مانند پلیس فتا، ممکن است برداشت رمزارز به مدت 24 تا 72
          ساعت کاری پس از زمان واریز از طریق درگاه شتابی، محدود گردد. کاربران
          ارزفی اذغان می‌دارند که از ریسک‌های مربوط به سرمایه‌گذاری در ارزهای
          دیجیتال مطلع بوده و با علم به این موضوع اقدام به سرمایه‌گذاری و تبادل
          می‌نمایند. ارزفی به عنوان بازار آنلاین تبادل ارزهای دیجیتال، هیچ گونه
          مسئولیتی در قبال نحوه‌ی معاملات کاربران و سود و زیان حاصل از آن ندارد.
          هرگونه سهل انگاری کاربران در حفظ اطلاعات امنیتی از جمله گذرواژه کاربر،
          به عهده‌ی شخص کاربر بوده و ارزفی هیچ مسئولیتی به عهده نخواهد داشت.
          اکیداً توصیه می شود از گذرواژه پیچیده و امن و کد شناسایی دوعاملی
          استفاده شود. ارزفی این اطمینان را می‌دهد که دارایی‌های کاربران را نزد
          خود به امانت و به بهترین شکل و با بالاترین استانداردهای امنیتی ممکن،
          حفظ نماید. در صورت بروز هرگونه مشکل امنیتی، ارزفی متعهد به جبران خسارت
          خواهد بود. در صورت تمایل برای برداشت ارزهای دیجیتال، مسئولیت ارائه‌ی
          آدرس صحیح کیف پول به عهده‌ی کاربر خواهد بود. در صورت بروز هر گونه مشکل
          اعم از اشتباه در ورود آدرس صحیح، نقص آدرس، مشکلات کیف پول مقصد و بلوکه
          شدن دارایی‌های کاربران در کیف پول مقصد، هیچ گونه مسئولیتی به عهده ی
          ارزفی نخواهد بود. ارزفی در مقابل واریز توکن یا کوین بر بستر اشتباه یا
          کوین هایی که در ارزفی پشتیبانی نمی شود هیچ گونه مسئولیتی نداشته و با
          توجه به مکانیسم ذخیره سازی سرد امکان استخراج این توکن ها با استفاده از
          ولت ثالث وجود ندارد. لذا مسئولیت هرگونه واریز اشتباه با خود کاربر بوده
          و کاربر حق هیچ گونه شکایتی را نخواهد داشت. درخواست برداشت ریال از حساب
          کاربری در سریع‌ترین زمان ممکن پس از ثبت، بررسی خواهد شد. زمان واریز
          پول به حساب کاربران بر اساس محدودیت‌های انتقال وجه بین بانکی، متفاوت
          خواهد بود. برای اطلاعات بیش‌تر، به قوانین انتقال وجه بین بانکی ( پایا
          ، ساتنا) مراجعه فرمایید. کاربر می‌پذیرد که به جز در موارد مورد تعهد
          ارزفی، حق هیچ گونه داعیه، طلب و شکایت از سایت ارزفی، مدیران، کارمندان
          و افراد مرتبط با این سایت را نخواهد داشت. اگر ارزفی تحت هر عنوان
          اشتباهاً یا من غیر حق، وجوه یا رمزارزی را به حساب کاربر منظور یا در
          محاسبات خود هر نوع اشتباهی نماید، هر زمان مجاز و مختار است راساً و
          مستقلاً و بدون انجام هیچ گونه تشریفات اداری و قضائی و دریافت اجازه
          کتبی از متعهد (صاحب حساب) در رفع اشتباه و برداشت از حساب‌های وی اقدام
          نماید و تشخیص ارزفی نسبت به وقوع اشتباه یا پرداخت بدون حق و لزوم
          برداشت از حساب معتبر خواهد بود و کاربر حق هرگونه اعتراض و ادعایی را در
          خصوص نحوه عملکرد ارزفی از هر جهت از خود ساقط می نماید. در صورت بروز
          هرگونه مشکل یا ابهام در هر یک از معاملات، ارزفی حق دارد مستقلاً آن
          معامله را ابطال و دارایی‌های هر یک از طرفین را به حساب خودشان عودت
          دهد. بدیهی است که در صورتی که اشکال از سمت ارزفی باشد، موظف خواهد بود
          که جبران خسارت نماید و در غیراین صورت کاربر حق هرگونه اعتراض و ادعایی
          را در خصوص نحوه عملکرد ارزفی از هر جهت از خود ساقط می‌نماید. در صورت
          هرگونه سوء استفاده از کد ریفرال ارزفی در فعالیت‌های خلاف قانون، تمامی
          مسئولیت آن به عهده کاربر بوده و ارزفی هیچ گونه مسئولیتی در قبال هرگونه
          سوء استفاده از سیستم معرفی خود به هر نحو ندارد. همچنین ارزفی حق باطل
          کردن کد معرف و بستن حساب در صورت مشاهده هرگونه سوء استفاده بدون نیاز
          به دستور قضایی را خواهد داشت.
        </p>
      </div>
      <div className={styles.checkbox_container}>
        <label htmlFor="acceptRulesOfSite">
          <input
            id="acceptRulesOfSite"
            type="checkbox"
            value={UserRulesInfo}
            onChange={(e) => {
              SetAcceptRules(e.target.checked);
            }}
          />
          <div className={`font_color_white ${styles.label_for_checkbox}`}>
            مطالعه کردم و میپذیرم
          </div>
        </label>
      </div>
    </div>
  );
};
{
  /* User Inforamtion include > CartID & Personal Information Components */
}
export const AuthenticationFileds = ({ docInfo }) => {
  const userInfo = useSelector((state) => state.fullUserInfo.data_profile);
  const [userInfoDetails, setUserInfoDetails] = useState();
  useEffect(() => {
    setUserInfoDetails(userInfo);
  }, [userInfo]);
  console.log(userInfo);
  useEffect(() => {
    let acc = document.getElementsByClassName("accordion-for-user-details");
    let panel = document.getElementsByClassName("panel-buttons");
    for (var i = 0; i < acc.length; i++) {
      acc[i].onclick = function () {
        let setClasses = !this.classList.contains("active-user-details");
        setClass(acc, "active-user-details", "remove");
        setClass(panel, "show", "remove");
        if (setClasses) {
          this.classList.toggle("active-user-details");
          this.nextElementSibling.classList.toggle("show");
        }
      };
    }
    function setClass(els, className, fnName) {
      for (let i = 0; i < els.length; i++) {
        els[i].classList[fnName](className);
      }
    }
  }, []);
  console.log(userInfoDetails);
  const [verificationDetails, setVerificationDetails] = useState({
    phoneCodeSend: false,
    phoneCode: "",
    emailCodeSend: false,
    emailCode: "",
  });
  const [checkEmailRead, setCheckEmailRead] = useState(false);
  const handleSendPhoneCodeVerify = async () => {
    try {
      const response = await sendPhoneCode();
      if (response.data.verify)
        setVerificationDetails({ ...verificationDetails, phoneCodeSend: true });
      else {
        errorMessage(response.data.message);
      }
    } catch (ex) {
      errorMessage("مشکلی پیش آمده! دوباره تلاش کنید");
    }
  };
  const handleSubmitPhoneCode = async () => {
    if (!verificationDetails.phoneCode) return;
    const code = verificationDetails.phoneCode;
    try {
      const res = await checkPhoneCode(code);
      if (res.data.verify) {
        successMessage("شماره شما تایید شد");
        setVerificationDetails({
          ...verificationDetails,
          phoneCodeSend: false,
        });
        setUserInfoDetails({
          ...userInfoDetails,
          ...(userInfoDetails.user.smsStatus = true),
        });
      }
    } catch (ex) {
      errorMessage("کد وارد شده اشتباه است");
    }
  };
  ///
  //Email Code Send And Verify
  ///
  const handleSendEmailCodeVerify = async () => {
    try {
      const response = await sendEmailCode();
      if (response.data.verify)
        setVerificationDetails({ ...verificationDetails, emailCodeSend: true });
      else {
        errorMessage(response.data.message);
      }
    } catch (ex) {
      errorMessage("مشکلی پیش آمده! دوباره تلاش کنید");
    }
  };
  const handleSubmitEmailCode = async () => {
    if (!verificationDetails.emailCode) return;
    const code = verificationDetails.emailCode;
    try {
      const res = await checkEmailCode(code);
      if (res.data.verify) {
        successMessage("ایمیل شما تایید شد");
        setVerificationDetails({
          ...verificationDetails,
          emailCodeSend: false,
        });
        setUserInfoDetails({
          ...userInfoDetails,
          ...(userInfoDetails.user.emailStatus = true),
        });
      }
    } catch (ex) {
      errorMessage("کد وارد شده اشتباه است");
    }
  };
  ///‌ End Email Verification
  console.log(docInfo);
  return (
    <section className={styles.AuthenticationFields_container}>
      <div className={styles.part_of_info}>
        <div
          className={`accordion-for-user-details ${styles.title_AuthenticationFields_container}`}
        >
          <div className={styles.icon}>
            <img
              src={UserFillIcon}
              alt=""
              width={20}
              height={20}
              className="convertPicToGreen"
            />
          </div>
          <div className={`font_color_white ${styles.title}`}>اطلاعات فردی</div>
          <div className={styles.ArrowIconContainer}>
            <img
              src={ArrowRightIcon}
              alt=""
              width={17}
              height={17}
              className="ArrowImgPersonalInfo convertPicToGreen"
            />
          </div>
        </div>
        <div className="panel-buttons">
          {/* In Code Zamani Ke karbar data nadashte bashe baz mishe PERSONAL INFO
          Dar Gheyre In surate Field Ba'adi Baz Mishe */}
          {!userInfoDetails?.user?.fullname ||
            !userInfoDetails?.user?.phoneNumber ||
            (!docInfo?.idNumber && (
              <div className={styles.item_status}>
                <div className={`font_color_white ${styles.grid_item}`}>
                  <div>وضعیت: </div>
                  <div className={styles.polygon_icon}></div>
                  <div className={styles.status_with_img}>
                    <img src={NotConfirmed} alt="Not" width={20} height={20} />
                  </div>
                  <div className={styles.button_to_fill_form}>
                    <Link to="/my-profile/authentication/personal-info">
                      تکمیل اطلاعات
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          <div className={styles.item_status}>
            <div className={`font_color_white ${styles.grid_item}`}>
              <div>نام و نام خانوادگی: </div>
              <div>{userInfoDetails?.user?.fullname}</div>
              <div className={styles.polygon_icon}></div>
            </div>
          </div>
          <div className={styles.item_status}>
            <div className={`font_color_white ${styles.grid_item}`}>
              <div>کد ملی: </div>
              <div>{/*PLACE OF ID NUMBER*/}</div>
              <div className={styles.polygon_icon}></div>
              <div className={styles.status_with_img}>
                <img
                  src={docInfo?.idNumber ? Confirmed : NotConfirmed}
                  alt="Not"
                  width={userInfoDetails?.user?.smsStatus ? 18 : 20}
                  height={userInfoDetails?.user?.smsStatus ? 18 : 20}
                />
              </div>
            </div>
          </div>
          <div className={styles.item_status}>
            <div className={`font_color_white ${styles.grid_item}`}>
              <div>شماره موبایل: </div>
              <div>{userInfoDetails?.user?.phoneNumber}</div>
              <div className={styles.polygon_icon}></div>
              <div className={styles.status_with_img}>
                <img
                  src={
                    userInfoDetails?.user?.smsStatus ? Confirmed : NotConfirmed
                  }
                  alt="Not"
                  width={userInfoDetails?.user?.smsStatus ? 18 : 20}
                  height={userInfoDetails?.user?.smsStatus ? 18 : 20}
                />
              </div>
              {!userInfoDetails?.user?.smsStatus &&
              userInfoDetails?.user?.phoneNumber ? (
                <button
                  className={styles.button_to_fill_form2}
                  disabled={verificationDetails.phoneCodeSend}
                  onClick={() => handleSendPhoneCodeVerify()}
                >
                  ارسال کد تایید
                </button>
              ) : (
                ""
              )}
            </div>
            {verificationDetails?.phoneCodeSend && (
              <div className={styles.input_verification}>
                <input
                  className="changeBackgroundToWhite changeFontColorToBlack"
                  type="text"
                  placeholder="کد ارسالی*"
                  onChange={(e) =>
                    setVerificationDetails({
                      ...verificationDetails,
                      phoneCode: e.target.value,
                    })
                  }
                  value={verificationDetails.phoneCode}
                />
                <button onClick={() => handleSubmitPhoneCode()}>ثبت</button>
              </div>
            )}
          </div>
          <div className={styles.item_status}>
            <div className={`font_color_white ${styles.grid_item}`}>
              <div>شماره ثابت: </div>
              <div>02155909090</div>
              <div className={styles.polygon_icon}></div>
              <div className={styles.status_with_img}>
                <img src={NotConfirmed} alt="" width={20} height={20} />
              </div>
            </div>
          </div>
          <div className={styles.item_status}>
            <div className={`font_color_white ${styles.grid_item}`}>
              <div>ایمیل: </div>
              <div className={styles.grid_force}>
                {!userInfoDetails?.user?.emailStatus &&
                userInfoDetails?.user?.email ? (
                  <button
                    className={styles.button_to_fill_form3}
                    disabled={verificationDetails.emailCodeSend}
                    onClick={() => handleSendEmailCodeVerify()}
                  >
                    ارسال کد تایید
                  </button>
                ) : (
                  ""
                )}
                <div>{userInfoDetails?.user?.email}</div>
              </div>
              <div className={styles.polygon_icon}></div>
              <div className={styles.status_with_img}>
                <img
                  src={
                    userInfoDetails?.user?.emailStatus
                      ? Confirmed
                      : NotConfirmed
                  }
                  alt=""
                  width={userInfoDetails?.user?.emailStatus ? 18 : 20}
                  height={userInfoDetails?.user?.emailStatus ? 18 : 20}
                />
              </div>
            </div>
            {verificationDetails.emailCodeSend && (
              <>
                <div className={styles.acceptEmailRules}>
                  <label htmlFor="accept_rules_in_email">
                    <div className={styles.grid_items}>
                      <input
                        type="checkbox"
                        id="accept_rules_in_email"
                        className={styles.read_email_checkbox}
                        value={checkEmailRead}
                        onChange={(e) => setCheckEmailRead(e.target.checked)}
                      />
                      <div className={styles.checkbox}></div>
                      <div className={`font_color_white ${styles.text_accept}`}>
                        قوانین ارسال شده در ایمیل را مطالعه کرده و میپذیرم
                      </div>
                    </div>
                  </label>
                </div>
                <div className={styles.input_verification}>
                  <input
                    className="changeBackgroundToWhite changeFontColorToBlack"
                    type="text"
                    placeholder="کد ارسالی*"
                    onChange={(e) =>
                      setVerificationDetails({
                        ...verificationDetails,
                        emailCode: e.target.value,
                      })
                    }
                    value={verificationDetails.emailCode}
                  />
                  <button
                    disabled={!checkEmailRead}
                    onClick={() => handleSubmitEmailCode()}
                  >
                    ثبت
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className={styles.part_of_info}>
        <div
          className={`accordion-for-user-details ${styles.title_AuthenticationFields_container}`}
        >
          <div className={styles.icon}>
            <img
              src={ScanIcon}
              alt=""
              width={20}
              height={20}
              className="convertPicToGreen"
            />
          </div>
          <div className={`font_color_white ${styles.title}`}> احراز هویت</div>
          <div className={styles.ArrowIconContainer}>
            <img
              src={ArrowRightIcon}
              alt=""
              width={17}
              height={17}
              className="ArrowImgPersonalInfo convertPicToGreen"
            />
          </div>
        </div>
        <div className="panel-buttons">
          <div className={styles.item_status}>
            <div className={`font_color_white ${styles.grid_item}`}>
              <div>تصویر کارت ملی: </div>
              <div className={styles.polygon_icon}></div>
              <div className={styles.status_with_img}>
                <img
                  src={
                    docInfo.IdCardPic === "APPROVED"
                      ? Confirmed
                      : docInfo.IdCardPic === "UNCHECKED"
                      ? pendingIcon
                      : NotConfirmed
                  }
                  alt="Not"
                  width={docInfo.IdCardPic === "APPROVED" ? 18 : 20}
                  height={docInfo.IdCardPic === "APPROVED" ? 18 : 20}
                />
              </div>
              {docInfo.IdCardPic !== "APPROVED" &&
                docInfo.IdCardPic !== "UNCHECKED" && (
                  <button className={styles.button_to_fill_form}>
                    <Link to="/my-profile/authentication/id-card">
                      تکمیل اطلاعات
                    </Link>
                  </button>
                )}
            </div>
          </div>
          <div className={styles.item_status}>
            <div className={`font_color_white ${styles.grid_item}`}>
              <div>تصویر احراز هویت: </div>
              <div className={styles.polygon_icon}></div>
              <div className={styles.status_with_img}>
                <img
                  src={
                    docInfo.personPic === "APPROVED"
                      ? Confirmed
                      : docInfo.personPic === "UNCHECKED"
                      ? pendingIcon
                      : NotConfirmed
                  }
                  alt=""
                  width={docInfo.personPic === "APPROVED" ? 18 : 20}
                  height={docInfo.personPic === "APPROVED" ? 18 : 20}
                />
              </div>
              {docInfo.personPic !== "APPROVED" &&
                docInfo.personPic !== "UNCHECKED" && (
                  <button className={styles.button_to_fill_form}>
                    <Link to="/my-profile/authentication/person-pic">
                      تکمیل اطلاعات
                    </Link>
                  </button>
                )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default function Authentication() {
  const history = useHistory();
  const [userRulesAccept, setUserRulesAccept] = useState(true);
  const dispatch = useDispatch();
  const loadingBar = useSelector((state) => state.loadingBar.loading);
  const [docInfo, setDocInfo] = useState({
    personPic: "",
    IdCardPic: "",
  });
  useEffect(() => {
    const getUserDetails = async () => {
      try {
        dispatch(showLoadingPage());
        await dispatch(userProfile());
        const verifyInfo = await usersVerifyInfo();
        setDocInfo({
          ...docInfo,
          personPic: verifyInfo.data.user.userSelfie,
          IdCardPic: verifyInfo.data.user.userIdCard,
          idNumber: verifyInfo.data.user.idNumber,
        });
        if (verifyInfo.data.user.userIdCard) {
          setUserRulesAccept(true);
        } else {
          setUserRulesAccept(false);
        }
      } catch (ex) {
      } finally {
        dispatch(hiddenLoadingPage());
      }
    };
    getUserDetails();
  }, []);

  return (
    <>
      {loadingBar && <LoadingPage />}
      <section className={styles.container}>
        <header>
          <div className={styles.back}>
            <img
              src={ArrowBackIcon}
              alt="BACK"
              width={15}
              height={15}
              onClick={() => history.push("/my-profile/info")}
              className="convertPicToWhite"
            />
          </div>
          <div className={`font_color_white ${styles.header_title}`}>
            احراز هویت
          </div>
        </header>
        <main>
          {userRulesAccept ? (
            <AuthenticationFileds docInfo={docInfo} />
          ) : (
            <UserAcceptRules
              SetAcceptRules={setUserRulesAccept}
              UserRulesInfo={userRulesAccept}
            />
          )}
        </main>
      </section>
    </>
  );
}
